/**
 * Compares two flat arrays of form component definitions (matched by `name`)
 * and reports which fields were added, removed, or changed. Used to preview
 * the effect of propagating a ClaimFormSectionTemplate update to a form that
 * has an older copy of the section materialized inline.
 */
export function diffComponents(oldComponents, newComponents) {
  const oldByName = new Map((oldComponents ?? []).map((c) => [c.name, c]));
  const newByName = new Map((newComponents ?? []).map((c) => [c.name, c]));

  const added = [...newByName.keys()].filter((name) => !oldByName.has(name));
  const removed = [...oldByName.keys()].filter((name) => !newByName.has(name));
  const changed = [...newByName.keys()].filter(
    (name) =>
      oldByName.has(name) &&
      JSON.stringify(oldByName.get(name)) !== JSON.stringify(newByName.get(name))
  );

  return {
    added,
    removed,
    changed,
    oldByName,
    newByName,
    isUpToDate: added.length === 0 && removed.length === 0 && changed.length === 0,
  };
}
